





























































































/* api */
import GetImageApi from '@/app/model/api/getImageApi'
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'

@Component
export default class FieldImg extends Vue {
  private showImgModal: boolean = false;
  private originalImagePath: string = ''
  private isLoading: boolean = false
  private displayImg: string = ''
  private isActive: boolean = false

  @Prop() private plantingId!: number
  @Prop() private cropImageId!: number | null
  @Prop() private date!: string
  @Prop() private imgPath!: string | null

  private get changeImgPath (): string | null {
    return this.imgPath
  }

  @Watch('changeImgPath')
  onChangeImgPath (path: string) {
    this.getDefaultImg()
  }

  private get changeCropImgId (): number | null {
    return this.cropImageId
  }

  @Watch('changeCropImgId')
  onChangeCropImgId (id: number) {
    this.getDefaultImg()
  }

  created () {
    this.getDefaultImg()
  }

  private async getDefaultImg () {
    if (this.imgPath !== '' && this.imgPath !== null && this.cropImageId === 0) {
      this.displayImg = this.imgPath
      return
    }

    if (this.cropImageId === null || this.cropImageId === 0) {
      this.isActive = true
      this.displayImg = require('@/assets/img/no_image.svg')
      return
    }

    let targetDate
    if (String(this.date).length === 8) {
      targetDate = this.date
    } else {
      const date = new Date(this.date)
      targetDate = date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate())
    }
    let body: any = {
      planting_id: this.plantingId,
      date: targetDate,
      crop_image_id: this.cropImageId,
      type: ''
    }

    const result = await GetImageApi.getImageData(body)
    this.displayImg = String(result)
  }

  /* モーダルのオリジナル画像を取得 */
  private async showModal () {
    this.showImgModal = true
    this.isLoading = true
    if (this.imgPath !== '' && this.imgPath !== null && this.cropImageId === 0) {
      this.originalImagePath = this.imgPath
      this.isLoading = false
      return
    }

    if (this.cropImageId === null || this.cropImageId === 0) {
      this.isActive = true
      this.originalImagePath = require('@/assets/img/no_image.svg')
      this.isLoading = false
      return
    }

    let targetDate
    if (String(this.date).length === 8) {
      targetDate = this.date
    } else {
      const date = new Date(this.date)
      targetDate = date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate())
    }
    let body: any = {
      planting_id: this.plantingId,
      date: targetDate,
      crop_image_id: this.cropImageId,
      type: 'original'
    }

    const result = await GetImageApi.getImageData(body)
    this.isLoading = false
    this.originalImagePath = String(result)
  }
}
